export class Utils {

    /**
     * Convert base64 into new file with extension.png
     * 
     * @param dataURI base64 data
     * @param fileName  name of the file
     */
    public static dataURItoBlob(dataURI: any, fileName: string): File {
        let byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
        else
            byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        const ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new File([ia], fileName + '.png', { type: 'image/png' });
    }

    /**
     * Rename a file creating a new one
     * @param originalFile 
     * @param newName 
     * @returns File 
     */

    public static renameFile(originalFile: any, newName: string, extension: any) {
        return new File([originalFile], newName.length >= 49 ? newName.substring(0, 45) + extension : newName + extension, {
            type: originalFile.type,
            lastModified: originalFile.lastModified,
        });
    }

    /**
     * Transform string value with ',' decimal to number
     * @param stringNumber
     * @returns number 
     */
    public static StringToNumber(stringNumber: { toString: () => any; }): any {
        try {
            let value = stringNumber.toString().replace(',', '.');
            value = +value.replace(/[A-Z]/i, '');
            return this.trunc(value) || 0
            //return value||0;
        }
        catch {
            return 0
        }
    }

    /**
     * Transform string value with '.' decimal to string with ',' decimal
     * @param value
     * @returns formatedValue 
     */
    public static getFormatedValue(value: string) {
        let formatedValue = Number.parseFloat(value).toFixed(2);
        formatedValue = formatedValue.toString().replace('.', ',')
        return formatedValue
    }


    /**
     * Truncate a number with n figures
     * @param x value to truncate
     * @param n number of figures to truncate
     * @returns truncated value 
     */
    public static trunc(x: { toString: () => any; }) {
        let ret = x;
        let str = x.toString();
        var decimalLength = str.indexOf('.')
        if (decimalLength > -1) {
            ret = Number(str.substring(0, decimalLength + 3))
        }
        return ret
    }

    /**
    * Converts the string str to Hexadecimal string , and returns this value
    * @param str value to convert
    *
    * @returns converted to HEX string 
    */
    public static strToHex(str: { length: number; charCodeAt: (arg0: number) => { (): any; new(): any; toString: { (arg0: number): string; new(): any; }; }; }): string {
        var result = "";
        for (var i = 0; i < str.length; i++) {
            result += str.charCodeAt(i).toString(16);
        }
        return result;
    }

    /**
   * Converts hexadecimal to string , and returns this value
   * @param hexx value to convert
   *
   * @returns converted to string 
   */


    public static hexToStr(hexx: { toString: () => any; }) {
        var hex = hexx.toString();//force conversion
        var str = '';
        for (var i = 0; i < hex.length; i += 2)
            str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
        return str;
    }

    public static cleanAccents(string: string) {
        return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    public static sanitizeString(input: string): string {
        const normalized = input.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return normalized.toLowerCase();
    }

    public static getProductDate(): string {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
  }
}